import * as api from 'config/api';

/* チャートコントロール表示期間の初期表示日数(1ヶ月,3ヶ月,6ヶ月,1年,全期間) */
export const chartLegTypes = [30, 90, 180, 360, -1];

/* チャートコントロール表示期間の最小表示日数 */
export const spanDay = 3;

/* 期間内の日数でカウント */
/*
export const countF = (chartRange: number, list: (any)[][] | undefined): number => {
  if (!list) return 0;

  const legCnt = chartLegTypes[chartRange];
  if (legCnt === -1) return list.length - 1

  const toDay = Number(formatDate(list[0][0], 'yyyyMMdd'));
  const toYM = Math.floor(toDay / 100)
  const toY = Math.floor(toDay / 10000);
  const toM = toYM - (toY * 100) - 1;
  const toD = toDay - (toYM * 100);

  const legDate = new Date(toY, toM, toD);
  legDate.setDate(legDate.getDate() - legCnt);
  const legDay = Number(formatDate(legDate, 'yyyyMMdd'));

  for (var n=list.length-1; n<=0; n--) {
    const fromDay = Number(formatDate(list[n][0], 'yyyyMMdd'));
    if (fromDay >= legDay) {
      return n;
    }
  }
  return legCnt - 1;
};
*/
const chkVal = (value: number | null) => {
  return value != null && value > 0 ? value : 0;
};
export const calcAmountTotal = (
  assetItem: api.GetAssetResultItem | undefined
) => {
  let total = 0;
  if (assetItem !== undefined) {
    total =
      chkVal(assetItem.StockAmount) +
      chkVal(assetItem.MarginAmount) +
      chkVal(assetItem.CashAmount) +
      chkVal(assetItem.OtherAmount);
  }
  return total;
};

export const calcRatio = (
  total: number | undefined,
  value: number | undefined | null
) => {
  return total === undefined ||
    total === null ||
    total === 0 ||
    value === undefined ||
    value === null
    ? '-'
    : Math.round((value / total) * 1000) / 10;
};

export const getAssetValue = (
  value: number | null,
  divided: number
): number | null => {
  return value === null ? null : value / divided;
};

export const getAmount = (
  amount: number | null,
  divided: number
): number | null => {
  return amount === null ? null : amount >= 0 ? amount / divided : 0; // マイナスは便宜上0とみなす
};

export const getAmountTotal = (
  amount: number | undefined | null
): number | undefined | null => {
  return amount === undefined
    ? undefined
    : amount === null
    ? null
    : amount >= 0
    ? amount
    : 0; // マイナスは便宜上0とみなす
};

export const toLocaleString = (amount: number | null | undefined): string => {
  return amount === undefined || amount === null ? '' : amount.toLocaleString();
};

export type MinMaxType = {
  min: number | null;
  max: number | null;
};

export type ChartSettingType = {
  coustomTicks: boolean;
};
export type CalculateVAxisType = {
  min: number | null;
  max: number | null;
  ticks: number[] | undefined;
  format: string;
};

// 値の小数点有効桁数を算出
const decimalPointLen = (value: number, maxLen: number): number => {
  const arr = String(value).split('.');
  return !arr[1] ? 0 : arr[1].length > maxLen ? maxLen : arr[1].length;
};

// 整数値に桁上げして、小数点以下を切り捨て
const floor = (value: number, pow: number) => {
  return Math.floor(value * pow) / pow;
};
// 整数値に桁上げして、小数点以下を切り上げ
const ceil = (value: number, pow: number) => {
  return Math.ceil(value * pow) / pow;
};

// ティックの表示形式
const getTickFormat = (unit: number): string => {
  // ティックの表示形式
  const amount = '#,###';
  const amountUnit: string =
    unit === 10000 ? '万' : unit === 100000000 ? '億' : '';
  return `${amount}.##${amountUnit}`;
};

// 最大値・最小値からティックを算出して、vAxisのパラメータを取得
const getVAxisParams = (
  min: number,
  max: number,
  format: string
): CalculateVAxisType => {
  let diff: number = max - min;
  // console.log(`オリジナル:: min=${min} max=${max} dif=${diff}`)

  // 値幅計算を整数で計算するため、小数点を桁上げする10のべき乗を算出
  // （値幅の小数点最大桁数は第3位として算出）
  const pow: number = Math.pow(10, decimalPointLen(diff, 3));

  // 元の値から、余白を含めた範囲を算出
  const marginRate = 0.1; // 10%の余白
  const margin: number = floor(diff * marginRate, pow);

  // 最小値（余白含む）
  min = floor(min - margin, pow);
  // 最小値の算出値が正であれば、最小値は０
  if (min > 0) min = 0;
  // 最大値（余白含む）
  max = ceil(max + margin, pow);
  // 最大値の算出値が負であれば、最大値は０
  if (max < 0) max = 0;
  // 値幅（余白含む）
  diff = (max * pow - min * pow) / pow;
  // console.log(`マージン計算::min=${min} max=${max} diff=${diff}(${max - min}) margin=${margin}`)

  // 指数
  const exponent: number = Math.pow(10, Math.floor(Math.log10(diff)));
  // 仮数（小数点有効桁数は小数点第1位までとする）
  const significand: number = floor(diff / exponent, Math.pow(10, 1));
  // 刻み判定
  const axisStep: number =
    significand < 1.5
      ? exponent / 5
      : significand < 3.5
      ? exponent / 2
      : //significand <= 5.0 ? exponent  * 1:
      significand <= 7.5
      ? exponent * 1
      : exponent * 2;
  // 刻みを考慮した最小値・最大値を計算するため、刻みを桁上げする10のべき乗を算出
  // （刻みの小数点最大桁数は第3位として算出）
  const stepPow: number = Math.pow(10, decimalPointLen(axisStep, 3));

  // 刻みを考慮して、最小値・最大値・値幅を再計算
  if (axisStep !== 0) {
    // 最小値
    min = (Math.floor(min / axisStep) * (axisStep * stepPow)) / stepPow;
    // 最大値
    max = (Math.ceil(max / axisStep) * (axisStep * stepPow)) / stepPow;
  }
  // 値幅
  // console.log(`calc min=${min} max=${max} axisStep=${axisStep} stepPow=${stepPow}`)

  // Tick値の算出
  const ticks: number[] | undefined = [];
  if (min === max) {
    // 値幅がなければ
    ticks.push(0);
  } else {
    // 値幅の範囲で算出
    let tick: number = min;
    for (let n = 0; n < 100; n++) {
      // 最大値を超えらたブレーク
      if (tick > max) break;

      // Tick追加
      ticks.push(tick);
      // ステップ値を加算して、Tickを算出
      tick = (tick * stepPow + axisStep * stepPow) / stepPow;
    }
  }
  return {
    min: min,
    max: max,
    ticks: ticks,
    format: format,
  };
};

// 資産推移の値軸算出
export const calculateVAxisForAssetAllocation = (
  assetList: Array<api.GetAssetResultItem> | undefined,
  unit: number
): CalculateVAxisType => {
  // Tickの表示形式
  const format: string = getTickFormat(unit);

  if (!assetList) {
    // 軸表示は、チャートコンポーネント側に任せる（nullやundefinedを指定）
    return { min: null, max: null, ticks: undefined, format: format };
  }

  // 表示領域の最大値・最小値・値幅を抽出
  const totalArray: number[] = assetList
    .filter(x => x.TotalAssetAmount !== null)
    .map(x => {
      const total =
        (x.StockAmount !== null && x.StockAmount > 0 ? x.StockAmount : 0) +
        (x.UnlistedStockAmount !== null && x.UnlistedStockAmount > 0
          ? x.UnlistedStockAmount
          : 0) +
        (x.InvestmentTrustAmount !== null && x.InvestmentTrustAmount > 0
          ? x.InvestmentTrustAmount
          : 0) +
        (x.USStockAmount !== null && x.USStockAmount > 0
          ? x.USStockAmount
          : 0) +
        (x.EtfEtnAmount !== null && x.EtfEtnAmount > 0 ? x.EtfEtnAmount : 0) +
        (x.ForeignEtfEtnAmount !== null && x.ForeignEtfEtnAmount > 0
          ? x.ForeignEtfEtnAmount
          : 0) +
        (x.ReitAmount !== null && x.ReitAmount > 0 ? x.ReitAmount : 0) +
        (x.ForeignReitAmount !== null && x.ForeignReitAmount > 0
          ? x.ForeignReitAmount
          : 0) +
        (x.BondAmount !== null && x.BondAmount > 0 ? x.BondAmount : 0) +
        (x.ForeignBondAmount !== null && x.ForeignBondAmount > 0
          ? x.ForeignBondAmount
          : 0) +
        (x.EbAmount !== null && x.EbAmount > 0 ? x.EbAmount : 0) +
        (x.ForeignEbAmount !== null && x.ForeignEbAmount > 0
          ? x.ForeignEbAmount
          : 0) +
        (x.RealEstateAmount !== null && x.RealEstateAmount > 0
          ? x.RealEstateAmount
          : 0) +
        (x.RoboAdvisorAmount !== null && x.RoboAdvisorAmount > 0
          ? x.RoboAdvisorAmount
          : 0) +
        (x.MarginAmount !== null && x.MarginAmount > 0 ? x.MarginAmount : 0) +
        (x.CashAmount !== null && x.CashAmount > 0 ? x.CashAmount : 0) +
        (x.OtherAmount !== null && x.OtherAmount > 0 ? x.OtherAmount : 0);
      return total / unit;
    });

  const min: number = Math.min.apply(null, totalArray);
  const max: number = Math.max.apply(null, totalArray);

  // 最大値・最小値からティックを算出し、vAxisのパラメータを取得
  return getVAxisParams(min, max, format);
};

export const maxTotalAssetAmount = (
  assetList: api.GetAssetResultItem[] | undefined
) => {
  if (!assetList) return 0;

  const totalAssetAmountList = assetList.map(x =>
    x.TotalAssetAmount !== null ? x.TotalAssetAmount : 0
  );
  return Math.max(...totalAssetAmountList);
};

export const calclateAssrtControl = (max: number) => {
  // 単位のルール
  // 1万円以下：円
  // 1億以下：万円
  // 1億以上：億円
  return Math.abs(max) <= 10000
    ? {
        unit: 1,
        format: '#,###',
        formatNum: '#,###',
        pattern: '#,###円',
        unitYen: '円',
      }
    : Math.abs(max) <= 100000000
    ? {
        unit: 10000,
        format: '#,###万',
        formatNum: '#,###',
        pattern: '#,###.##万円',
        unitYen: '万円',
      }
    : {
        unit: 100000000,
        format: '#,###億',
        formatNum: '#,###',
        pattern: '#,###.##億円',
        unitYen: '億円',
      };
};

/* レポートチャートの指定期間の切替で、比較元のYieldデータを参照切替 */
export const getYieldValue = (
  chartRange: number,
  obj: api.Performance,
  index: number,
  length: number
) => {
  return index >= length
    ? null
    : chartRange === 0
    ? obj.Yield1M
    : chartRange === 1
    ? obj.Yield3M
    : chartRange === 2
    ? obj.Yield6M
    : chartRange === 3
    ? obj.Yield1Y
    : obj.YieldAll;
};

/* レポートチャートの指定期間の切替で、比較先のYieldデータを参照切替 */
export const getYieldValueOrNull = (
  chartRange: number,
  items: api.Performance[],
  index: number
) => {
  return items && items.length > index
    ? getYieldValue(chartRange, items[index], index, items.length)
    : null;
};
